<template>
	<div>
		<div class="tabs overflow_hide">
			<ul>
				<li v-for="r in routers" :key="r.name">
					<div @click="changeStatus(r)" :class="r.active?'active':''">
						{{r.name}}
					</div>
				</li>
			</ul>
		</div>
		<div class="search-box overflow_hide">
			<el-button type="primary" class="fl" @click="uploadResource">上传资源</el-button>
			<el-button type="primary" class="fl" @click="setCheck">多选模式</el-button>
			<el-button type="primary" v-if="searchInfo.andModel.status===0" class="fl" @click="publicResource">发布
			</el-button>
			<el-button type="primary" v-else class="fl" @click="cancelPublic">取消发布</el-button>
		</div>
		<ResourceList
				:resource="resource"
				:pageSize=searchInfo.pageObject.pageSize
				:size="total"
				ref="resourceList"
				@changeCurrent="changeCurrent"
				@del="del"
				moduleName="VideoResource"></ResourceList>
	</div>
</template>

<script>
    import ResourceList from '../../components/ResourceList'
    import Utils from '../../assets/js/Utils'

    export default {
        name: "PersonalResource",
        data() {
            return {
                routers: [
                    {name: "已发布", status: 2, active: true},
                    {name: "未发布", status: 0},
                ],
                searchInfo: {
                    pageObject: {
                        pageSize: 8,
                        currentPage: 1
                    },
                    andModel: {
                        creator: this.$store.getters.getToken.id,
                        status: 2
                    }
                },
                total: 0,         //总分页条数
                resource: []
            }
        },
        components: {ResourceList},
        created() {
            this.getResource();
        },
        methods: {
            getResource() {
                this.$json("resource/page", "POST", this.searchInfo).then(res => {
                    this.total = res.total;
                    this.resource = res.data;
                });
            },
            //分页
            changeCurrent(data) {
                this.searchInfo.pageObject.currentPage = data;
                this.getResource(this.searchInfo);
            },
            //点击资源上传
            uploadResource() {
                this.$store.dispatch('setUploadVisible', true);
                Utils.$emit('clearForm');
            },
            //多选模式
            setCheck() {
                this.$refs.resourceList.checkMode = !this.$refs.resourceList.checkMode;
            },
            //发布
            publicResource() {
                this.$json("/course/publish", "POST", {ids: this.$refs.resourceList.chooseArr}).then(() => {
                    this.$refs.resourceList.checkMode = false;
                })
            },
            //取消发布
            cancelPublic() {
                this.$json("/resource/close", "POST", {ids: [48]}).then(res => {
                    this.$refs.resourceList.checkMode = false;
                })
            },
            del(id) {
                this.$confirm('是否确认删除该资源?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$json("/resource/" + id, "DELETE", {}).then(() => {
                        this.getResource();
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            changeStatus(r) {
                this.$nextTick(function () {
                    this.routers.forEach((v) => {
                        this.$set(v, 'active', false);
                    });
                    this.$set(r, 'active', true);
                });
                this.searchInfo.andModel.status = r.status;
                this.getResource();
            }
        }
    }
</script>

<style scoped lang="less">
	.tabs {
		margin: 10px 0;
		ul{
			li {
				float: left;
				min-width: 120px;
				height: 35px;
				line-height: 35px;
				font-size: 16px;
				cursor: pointer;
				a {
					width: 100%;
					height: 40px;
					display: block;
				}
			}
		}
	}
	.active{
		background-color: #8d8b8c;
		border-top-left-radius:10px;
		border-top-right-radius:10px;
		color:#fff;
	}

</style>
